module.exports = __webpack_public_path__ + "img/pepolechannel_plane_icon.3c06b0a5.png";